import * as React from "react";

import { Toggle, ToggleGroup } from "@/shared/foundation/primitives";

import styles from "./AiModels.module.css";
import { BedrockCatalog } from "./BedrockCatalog";
import { BedrockModelRoles } from "./BedrockModelRoles";
import { OrgModelConfigs } from "./OrgModelConfigs";

type AiModelsView = "orgs" | "catalog";

/**
 * The admin "AI Models" tab: every org's model configuration (with bulk
 * actions), and the Bedrock model catalog those configurations draw from,
 * with the deployment-wide model roles bound to its entries.
 */
export function AiModels() {
  const [view, setView] = React.useState<AiModelsView>("orgs");

  return (
    <div className={styles.container}>
      <ToggleGroup<AiModelsView>
        aria-label="AI models view"
        size="sm"
        value={[view]}
        onValueChange={([next]) => {
          // Pressing the shown view again would clear the group; ignore it.
          if (next !== undefined) {
            setView(next);
          }
        }}
      >
        <Toggle<AiModelsView> value="orgs">Orgs</Toggle>
        <Toggle<AiModelsView> value="catalog">Bedrock models</Toggle>
      </ToggleGroup>
      {view === "orgs" ? (
        <OrgModelConfigs />
      ) : (
        <>
          <BedrockCatalog />
          <BedrockModelRoles />
        </>
      )}
    </div>
  );
}
